import { CheckCircleOutlined } from '@ant-design/icons';
import { Card, Button } from 'antd';
import { Routes } from 'business/router/constants';
import { RingCompleteStatusTag } from 'business/tunnel/pages/ring-complete/components/status-tag';
import { useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { useTranslation } from 'translations/hooks';
import { Content } from 'ui/components/content';

const REDIRECTION_TIMER = 3000;

export const RingCompletePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const ringNumber = searchParams.get('ringNumber');

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(Routes.App);
    }, REDIRECTION_TIMER);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Content>
      <div className="flex w-full flex-1 flex-col items-center justify-center gap-y-6 px-12 text-center">
        <CheckCircleOutlined className="text-2xl" />
        <h1 className="max-w-xs text-lg">{t('tunnel.complete.title')}</h1>
        <Card className="w-full p-3">
          <div className="flex justify-between">
            <div>{ringNumber}</div>
            <RingCompleteStatusTag />
          </div>
        </Card>
      </div>

      <Link to={Routes.App} className="w-full py-4">
        <Button type="primary" className="w-full" htmlType="submit">
          {t('common.validate')}
        </Button>
      </Link>
    </Content>
  );
};
